import React, { Component } from "react";

import { Container, Row, Col, Table, Form } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonButton from '../components/CommonButton';
import CommonBadgeOptions from '../components/CommonBadgeOptions';
import CommonBadgeOptionsText from '../components/CommonBadgeOptionsText';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

/**
import CommonRowId from '../components/CommonRowId';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonImagePreview from '../components/CommonImagePreview';
*/

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

class DataTableUserDataPermission extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount = () =>  {}

    render() {

        let props = this.props;

        let { onSetEdit } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, Masterbase } = props;
        
        let rowId = fn.getRowIdStart(DataTable.pagination);

        let userTypes = options.usersPermission.mainType.options;

        let masterSubtypes = Masterbase.permission_name;

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead>
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-auto"></th>
                                        <th className="th-td-align-center th-width-50p"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {
                                        
                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                        
                                        rowId++;

                                        let types = userTypes.find(option => option.id === row.types);
                                        
                                        // let subtypes = masterSubtypes.find(option => option.types === row.types && option.subtypes === row.subtypes);
                                        let subtypes = masterSubtypes?.find(
                                            option =>
                                                String(option.types) === String(row?.types) &&
                                                String(option.id) === String(row?.subtypes)
                                        ) ?? null;
                                        
                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <div
                                                            className={`rounded-circle d-flex align-items-center justify-content-center bg-${types?.variant}`}
                                                            style={{ width: '40px', height: '40px' }}
                                                        >
                                                            <i className={`${types.icon} text-white`} style={{ fontSize: '20px' }} />
                                                        </div>
                                                    </td>
                                                    <td className="text-truncate" title={types.label}>
                                                        {types.label}
                                                        {subtypes?.name && (
                                                            <>
                                                            {" ( "}
                                                                {subtypes?.name}
                                                            {" ) "}
                                                            </>
                                                        )}
                                                        {/* {row.subtypes?.length  && (
                                                            <>
                                                                {" ("}
                                                                {row.subtypes
                                                                    .filter(item => item.types === types.id)
                                                                    .map(item => {
                                                                        const permission = Masterbase.permission_name.find(
                                                                            p => p.id === item.subtypes
                                                                        );

                                                                        return permission?.permission_name;
                                                                    })
                                                                    .filter(Boolean)
                                                                    .join(", ")}
                                                                {")"}
                                                            </>
                                                        )} */}

                                                        <p className="title-md mb-0">
                                                            <CommonBadgeOptionsText id={row.displayTypeA} text={`หลักสูตร Type A`} icon={true} options={options.status.users_task_permission.options} inlineClass="ms-2 mt-1 me-4" /> 
                                                            <CommonBadgeOptionsText id={row.displayTypeB} text={`หลักสูตร Type B`} icon={true} options={options.status.users_task_permission.options} inlineClass="ms-2 mt-1 me-4" /> 
                                                            <CommonBadgeOptionsText id={row.displayDemand} text={`ความต้องการกำลังคน`} icon={true} options={options.status.users_task_permission.options} inlineClass="ms-2 mt-1 me-4" /> 
                                                            <CommonBadgeOptionsText id={row.displayPublicize} text={`ประชาสัมพันธ์`} icon={true} options={options.status.users_task_permission.options} inlineClass="ms-2 mt-1 me-4" />
                                                            <CommonBadgeOptionsText id={row.displayEEC} text={`ศูนย์เครือข่าย`} icon={true} options={options.status.users_task_permission.options} inlineClass="ms-2 mt-1 me-4" /> 
                                                            <CommonBadgeOptionsText id={row.displayUsers} text={`ผู้ใช้และระดับสิทธิ์`} icon={true} options={options.status.users_task_permission.options} inlineClass="ms-2 mt-1 me-4" /> 
                                                        </p>
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="configuration" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableUserDataPermission;